import { Fragment, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { List, CheckLg } from "react-bootstrap-icons";
import Loader from "react-loader-spinner";
import { saveSystemSettings } from "../../store/api/SystemSettingsAPI";
import { setStoragePoup } from "../../store/api/Modals";
import ModalSearchStorage from "../../Common/ModalSearchStorage";
import { Button, Col, Form } from "react-bootstrap";


const GeneralSettings = (props) => {
    const dispatch = useDispatch();
    const settingValues = useRef({});
    const [pending, setPending] = useState(false);
    const [destStg, selectDestStg] = useState("");
    const [sourceStg, selectSourceStg] = useState("");
    const { findCheckedSetting, findSetting } = props;

    const save = () => {
        setPending(true);
        if (destStg && destStg.HardCode && destStg.HardCode !== "") {
            if (destStg.HardCode !== "-1") {
                settingValues.current.DefaultDestinationStorageHardCode = destStg.HardCode;
                settingValues.current.DefaultDestStorageName = destStg.StorageName;
            }
            else {
                settingValues.current.DefaultDestinationStorageHardCode = "";
                settingValues.current.DefaultDestStorageName = "";
            }
        }
        if (sourceStg?.HardCode && sourceStg.HardCode !== "") {
            if (sourceStg.HardCode === "-1") {
                settingValues.current.DefaultSourceStorageHardCode = "";
                settingValues.current.DefaultSourceStorageName = "";
            }
            else {
                settingValues.current.DefaultSourceStorageHardCode = sourceStg.HardCode;
                settingValues.current.DefaultSourceStorageName = sourceStg.StorageName;
            }
        }
        dispatch(saveSystemSettings(settingValues.current, () => { setPending(false) }));
    }
    function onChangeSetting(e) {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        settingValues.current[e.target.name] = value;
    }
    function showSourceStorage() {
        const onSelect = (stg) => {
            if (stg) {
                selectSourceStg(stg);
            }
            else {
                selectSourceStg({ HardCode: "-1", StorageName: "" });
            }
        }
        dispatch(setStoragePoup({ show: true, onSelect: onSelect }));
    }
    function showDestStorage(){
        const onSelect = (stg)=>{
            if(stg)
            {
                selectDestStg(stg);
            }
            else{
                selectDestStg({HardCode:"-1", StorageName:""});
            }
        }
        dispatch(setStoragePoup({ show: true, onSelect: onSelect }));
    }
    return (
        <Fragment>
            <ModalSearchStorage />
            <div className="row" style={{ fontSize: "12px" }}>
                <div className="form-group col-md-2">
                    <label>نام شرکت/نمایندگی</label>
                    <input type="text" className="form-control" name="CompanyName" defaultValue={findSetting("CompanyName")}
                        onChange={onChangeSetting} />
                </div>
                <div className="form-group col-md-2">
                    <label>کد شرکت/نمایندگی</label>
                    <input type="text" className="form-control" name="CompanyCode" defaultValue={findSetting("CompanyCode")}
                        onChange={onChangeSetting} />
                </div>
                <Col md={2} className="form-group">
                    <label>کد اقتصادی شرکت</label>
                    <Form.Control name="CommercialCode" defaultValue={findSetting("CommercialCode")} onChange={onChangeSetting} />
                </Col>
                <div className="form-group col-md-2">
                    <label>شماره تماس شرکت</label>
                    <input type="text" className="form-control" name="CompanyTell" defaultValue={findSetting("CompanyTell")}
                        onChange={onChangeSetting} />
                </div>
                <div className="form-group col-md-4">
                    <label>آدرس شرکت/نمایندگی</label>
                    <input type="text" className="form-control" name="CompanyAddress" defaultValue={findSetting("CompanyAddress")}
                        onChange={onChangeSetting} />
                </div>
                <Col md={2} className="form-group">
                    <label className="ellipsisLabel">آدرس API اداره مالیات</label>
                    <Form.Control style={{ direction: "ltr" }} name="TaxOfficeAPIAddress" defaultValue={findSetting("TaxOfficeAPIAddress")}
                        onChange={onChangeSetting} />
                </Col>
                <Col md={2} className="form-group">
                    <label className="ellipsisLabel">شناسه یکتای مالیاتی</label>
                    <Form.Control name="UniqueTaxIdentifier" style={{ direction: "ltr" }} defaultValue={findSetting("UniqueTaxIdentifier")} onChange={onChangeSetting} />
                </Col>
                <Col md={2} className="form-group">
                    <label className="ellipsisLabel">شناسه کلید امضا</label>
                    <Form.Control name="SigningKeyID" style={{ direction: "ltr" }} defaultValue={findSetting("SigningKeyID")} onChange={onChangeSetting} />
                </Col>
                <div className="form-group col-md-2">
                    <label className="ellipsisLabel">انبار مبدا پیش فرض</label>
                    <input type="text" className="form-control" name="DefaultSourceStorageHardCode"
                        value={sourceStg?.StorageName ?? findSetting("DefaultSourceStorageName")} readOnly />
                    <Button className="btn-input-tiny"><List size={17} onClick={showSourceStorage} /></Button>
                </div>
                <div className="form-group col-md-2">
                    <label className="ellipsisLabel">انبار مقصد پیش فرض</label>
                    <input type="text" className="form-control" name="DefaultDestinationStorageHardCode"
                        readOnly value={destStg?.StorageName ?? findSetting("DefaultDestStorageName")} />
                    <Button className="btn-input-tiny" onClick={showDestStorage}><List size={17} /></Button>
                </div>
                <div className="form-group col-md-2">
                    <label className="ellipsisLabel">درصد مالیات پیش فرض</label>
                    <input type="number" className="form-control" name="TaxPercent" defaultValue={findSetting("TaxPercent")}
                        onChange={onChangeSetting} />
                </div>
                <div className="form-group col-md-2">
                    <label>طول بارکد کالا</label>
                    <input type="number" className="form-control" name="ProductCodeLength" defaultValue={findSetting("ProductCodeLength")}
                        onChange={onChangeSetting} />
                </div>
                <div className="form-group col-md-2">
                    <label className="ellipsisLabel">نحوه تقسیم بندی کالا</label>
                    <select className="form-control" name="ProductGrouppingType" defaultValue={findSetting("ProductGrouppingType")}
                        onChange={onChangeSetting}>
                        <option value="0">مارک، نوع، مدل</option>
                        <option value="1">گروه‏بندی، نام، مدل</option>
                    </select>
                </div>
                <div className="form-group col-md-8" style={{ display: "flex", alignItems: "flex-end" }}>
                    <div>
                        <div style={{ display: "inline-block", padding: "5px" }}>
                            <input type="checkbox" className="form-check-input" name="IncludeCodeInserial" defaultChecked={findCheckedSetting("IncludeCodeInserial")}
                                onChange={e => settingValues.current.IncludeCodeInserial = e.target.checked} id="chkIncludeCodeInserial" />&nbsp;
                            <label htmlFor="chkIncludeCodeInserial">حضور کد کالا در سریال هنگام استفاده از بارکدخوان</label>
                        </div>
                        <div style={{ display: "inline-block", padding: "5px" }}>
                            <input type="checkbox" className="form-check-input" name="Invoices_UseProductTableForProductLastPrice"
                                defaultChecked={findCheckedSetting("Invoices_UseProductTableForProductLastPrice")}
                                onChange={onChangeSetting} id="chkUseProductTableForProductLastPrice" />&nbsp;
                            <label htmlFor="chkUseProductTableForProductLastPrice">قیمت خرید و فروش از مشخصات قطعه استخراج شود</label>
                        </div>
                        <div style={{ display: "inline-block", padding: "5px" }}>
                            <input type="checkbox" className="form-check-input" name="SendSMSForNewTicket"
                                defaultChecked={findCheckedSetting("SendSMSForNewTicket")}
                                onChange={onChangeSetting} id="chkSendSMSForNewTicket" />&nbsp;
                            <label htmlFor="chkSendSMSForNewTicket">ارسال پیامک برای تیکت جدید</label>
                        </div>
                        <div style={{ display: "inline-block", padding: "5px" }}>
                            <input type="checkbox" className="form-check-input" name="SendSMSForNewNotice"
                                defaultChecked={findCheckedSetting("SendSMSForNewNotice")}
                                onChange={onChangeSetting} id="chkSendSMSForNewNotice" />&nbsp;
                            <label htmlFor="chkSendSMSForNewNotice">ارسال پیامک برای اطلاع جدید</label>
                        </div>
                    </div>
                </div>
            </div>
            <button className="mt-2 btn btn-success group-Btn" onClick={save} disabled={pending}>{pending === true && <Loader type="BallTriangle" color="white" style={{ display: "inline-block" }} width={20} height={20} />}{!pending && <CheckLg size={12} />}&nbsp;ذخیره تغییرات</button>
        </Fragment>
    )
}
export default GeneralSettings;